var render = function render(){
  var _vm$subject_selected, _vm$session_selected, _vm$session_selected2, _vm$trial_selected;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-expansion-panels', {
    model: {
      value: _vm.panel,
      callback: function ($$v) {
        _vm.panel = $$v;
      },
      expression: "panel"
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', [_vm._v(" " + _vm._s((_vm$subject_selected = _vm.subject_selected) === null || _vm$subject_selected === void 0 ? void 0 : _vm$subject_selected.name) + " " + _vm._s(_vm.session_selected ? "|" : "") + " " + _vm._s(((_vm$session_selected = _vm.session_selected) === null || _vm$session_selected === void 0 ? void 0 : _vm$session_selected.meta['sessionName']) || ((_vm$session_selected2 = _vm.session_selected) === null || _vm$session_selected2 === void 0 ? void 0 : _vm$session_selected2.id.split('-')[0])) + " " + _vm._s(_vm.trial_selected ? "|" : "") + " " + _vm._s((_vm$trial_selected = _vm.trial_selected) === null || _vm$trial_selected === void 0 ? void 0 : _vm$trial_selected.name) + " ")]), _vm.selection_index > 0 ? _c('div', [_c('v-btn', {
    staticStyle: {
      "width": "30px"
    },
    attrs: {
      "title": "Remove"
    },
    nativeOn: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.emitTrialRemove.apply(null, arguments);
      }
    }
  }, [_vm._v(" ✖")])], 1) : _vm._e()])]), _c('v-expansion-panel-content', {
    attrs: {
      "eager": ""
    }
  }, [_c('div', {
    staticClass: "mt-2"
  }), _c('v-select', {
    attrs: {
      "item-value": "id",
      "item-text": "name",
      "items": _vm.loaded_subjects,
      "label": "Select subject",
      "outlined": "",
      "dense": "",
      "return-object": ""
    },
    on: {
      "change": _vm.loadSessions
    },
    model: {
      value: _vm.subject_selected,
      callback: function ($$v) {
        _vm.subject_selected = $$v;
      },
      expression: "subject_selected"
    }
  }), _c('v-select', {
    attrs: {
      "item-value": "id",
      "item-text": function (item) {
        return item.meta['sessionName'] ? item.meta['sessionName'] + ' (' + item.id + ')' : item.id;
      },
      "items": _vm.loaded_sessions,
      "disabled": !_vm.subject_selected,
      "label": "Select session",
      "outlined": "",
      "dense": "",
      "return-object": ""
    },
    on: {
      "change": _vm.loadTrials
    },
    model: {
      value: _vm.session_selected,
      callback: function ($$v) {
        _vm.session_selected = $$v;
      },
      expression: "session_selected"
    }
  }), _c('v-select', {
    attrs: {
      "item-value": "id",
      "item-text": "name",
      "items": _vm.loaded_trials,
      "disabled": !_vm.session_selected,
      "label": "Select trial",
      "outlined": "",
      "dense": "",
      "return-object": ""
    },
    model: {
      value: _vm.trial_selected,
      callback: function ($$v) {
        _vm.trial_selected = $$v;
      },
      expression: "trial_selected"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "mb-2"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }